<bn-loading-overlay></bn-loading-overlay>
<ng-template #carregando>
    <div class="loading-pesquisa">
        <i class="bn-loading"></i>
    </div>
</ng-template>

<h5>SCR - Pesquisa de Associados</h5>

<div class="container" *ngIf="pesquisaForm; else carregando">

    <div class="mt-3 mx-auto">

        <div class="row">
            <div class="col">
                <h3>Filtros de pesquisa</h3>
            </div>

            <div class="col-auto">
                <button *ngIf="podeEnviarScr" type="button" class="btn no-margin btn-info" (click)="abrirModalCadastro()">Adicionar</button>
            </div>

            <!-- <div class="col-auto">
                <button class="btn btn-primary no-margin" type="button" placement="bottom"
                    ngbTooltip="Tela para realizar a importação de arquivo mensal."
                    routerLink="/integracao/scr/importacao"
                    [disabled]="!podeEnviarScr">
                    Importar Arquivo
                </button>

            </div> -->
            

            <div class="col-auto">
                <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
            </div>

            <div class="col-auto">
                <button #focusableSubmit type="button" class="btn btn-success no-margin" (keydown.enter)="buscar()"
                    (click)="buscar()" [disabled]="!pesquisaForm.valid">Pesquisar
                </button>

            </div>
        </div>

        <div class="mt-3 row" [formGroup]="pesquisaForm" >

            <div class="col-md-6 bn-form-group">
                <label>Agente Financeiro:</label>
                <select class="form-select" name="agenteFinanceiro" ngDefaultControl
                    formControlName="agenteFinanceiro">
                    <option [ngValue]=null>Todos</option>
                    <option *ngFor="let agente of agentesFinanceiros" [ngValue]="agente.id">{{ agente.nome }}
                    </option>
                </select>
            </div>

            <div class="bn-form-group col-md-6">
                <label>CNPJ Associado:</label>
                <input type="text" class="form-control" formControlName="cnpjAssociado">
            </div>

        </div>

        <app-scr-associados-listagem class="row" 
            *ngIf="pesquisado"
            [hidden]="esconderPesquisa"
            [associados]="associados" 
            [podeEnviarScr]="podeEnviarScr"
            [agentesFinanceiros]="agentesFinanceiros"
            [atributosPaginacao]="atributosPaginacaoComponenteListagem"
            (aoMudarPagina)="mudancaPagina($event)"
            (aoExportarAssociados)="exportarAssociados()">
        </app-scr-associados-listagem>
    </div>
</div>